/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserProjectsQueryResult } from '../../models/get-user-projects-query-result';

export interface ApiProjectGetCurrentUserProjectsPost$Plain$Params {
}

export function apiProjectGetCurrentUserProjectsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectGetCurrentUserProjectsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserProjectsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectGetCurrentUserProjectsPost$Plain.PATH, 'post');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserProjectsQueryResult>;
    })
  );
}

apiProjectGetCurrentUserProjectsPost$Plain.PATH = '/api/Project/GetCurrentUserProjects';
